<h1 matDialogTitle>
  <ng-container *ngIf="!data?.boxInterface?.id">New Interface</ng-container>
  <ng-container *ngIf="data?.boxInterface?.id">Edit Interface</ng-container>
</h1>
<mat-dialog-content>

  <aw-box-interface-form [boxInterface]="data.boxInterface" [creatingFromBox]="creatingFromBox"
    (boxInterfaceEmitter)="returnBoxInterface($event)" (saved)="dialogRef.close(returnThisInDialogClose)"
    (canceled)="dialogRef.close(false)"></aw-box-interface-form>

</mat-dialog-content>